export const CHECKOUT_PAGE_NS = 'pages/Checkout';

export const i18n = {
  en: {
    buttons: { back: 'Back' },
    return: {
      processing: {
        title: 'Processing payment',
      },
      paymentCompleted: {
        title: 'Payment completed',
        subtitle: 'We appreciate your business! A confirmation email will be sent to {{email}}.',
      },
      paymentError: {
        title: 'Payment session error',
        subtitle: 'Navigating to the ecosystem in 2 seconds...',
      },
    },
  },
};
